import { AuthService } from 'src/app/shared/service/auth.service';
import { AuthGuard } from '../../shared/guard/auth.guard';
import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList, AngularFireObject } from '@angular/fire/database';
import * as firebase from 'firebase';
import { Operating } from "../../models/operating";
import { ActivatedRoute, Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { data } from 'jquery';



@Injectable({
  providedIn: 'root'
})
export class FirePracticalAssessmentService {
  assessmentsRef: AngularFireList<any>; // Reference to Assessment data list, its an Observable
  assessmentRef: AngularFireObject<any>; // Reference to assessment object
  public database = firebase.database();
  public ref;
  public actRoute: ActivatedRoute;
  public router: Router;
  public auth: AuthGuard;
  public dbStore = firebase.firestore();
  private dbPath = 'users';
  private assessmentsTable = "operating-assessment-inputs";

  sustainibleAssessmentRef: AngularFirestoreCollection<Operating> = null;

  constructor(
    private db: AngularFireDatabase, 
    private authService: AuthService, 
    private guard: AuthGuard, 
    private dbstore: AngularFirestore
    ) {
    this.sustainibleAssessmentRef = dbstore.collection(this.assessmentsTable);
  }


  // Firestore Assessment Create the Assessment in FireStore
  createSustainibleeAssessment(sustainible: Operating): void {
    this.sustainibleAssessmentRef.add({ ...sustainible });

  }

  updateSustainibleeAssessment(id: string, value: any): Promise<void> {
    return this.sustainibleAssessmentRef.doc(id).update(value);

  }

  deleteSustainibleeAssessment(id: string): Promise<void> {
    return this.sustainibleAssessmentRef.doc(id).delete();

  }

  readSustainibleeAssessmentList(): AngularFirestoreCollection<Operating> {
    return this.sustainibleAssessmentRef;

  }

  readAssessmentsListOperating() {
    
    this.globalAdminCode(this.guard.uid);
 
   const list = this.dbstore.collection<any>(this.assessmentsTable, ref => ref.where('userID', '==', this.guard.uid));
    return list;
  }


  readSustainibleAssessment(id: string) {
    return this.sustainibleAssessmentRef.doc(id);
  }

  deleteAllSustainibleeAssessment() {
    this.sustainibleAssessmentRef.get().subscribe(
      (querySnapshot) => {
        querySnapshot.forEach((doc) => {
          doc.ref.delete();
        });
      },
      error => {
        console.error('Error deleting all documents: ', error);
      });
  }

  /**
   * Create assessment in firestore
   * @param practical - data about practical assessment
   * @returns 
   */

  async createAssessment(practical: Operating): Promise<string> {
    const adminCodePayload: any = (
      await this.dbStore
        .collection(this.dbPath)
        .doc(this.authService.userData?.uid || this.guard.uid)
        .get()
    )?.data()?.adminCode;
   // const adminCode = (await this.dbStore.collection(this.dbPath).doc(this.guard.uid).get())?.data()?.adminCode;
    const data = {
      userID: this.authService.userData?.uid || this.guard.uid,
      adminCode: !adminCodePayload?.disabled ? adminCodePayload: null,
      ...practical
    };

    const res = await this.sustainibleAssessmentRef.add(data);
    
    return res.id;

  }

 public adminCode2: any;
  assessmentInput: any;

 globalAdminCode(uid: string) {
    
     this.dbStore
     .collection(this.dbPath)
     .doc(uid)
     .get()
     .then((snapshot) => {
      this.assessmentInput = snapshot.data();
      this.adminCode2 = this.assessmentInput.adminCode;
    
  });
}


  ReadAssessment(id: string) {
    this.assessmentRef = this.db.object(`users/${this.guard.uid}/` + id);
    return this.assessmentRef;
  }

  readAssessmentsList() {
    
 //const list = this.dbstore.collection<any>(this.assessmentsTable, ref => ref.where('userID', '==', this.guard.uid));
//  const list = this.dbstore.collection<any>(`users`, ref => ref.where(this.guard.uid, '==', this.guard.uid));
    this.globalAdminCode(this.guard.uid);
 /*  this.dbStore.collection(this.dbPath).doc(this.guard.uid).get().then((snapshot) => { 
    this.assessmentInput = snapshot.data();
    this.adminCode2 = this.assessmentInput.adminCode;
   
   });*/

   const list = this.dbstore.collection<any>(this.assessmentsTable, ref => ref.where('userID', '==', this.guard.uid) || ref.where('adminCode', '==', this.adminCode2));
   
   // const list = this.dbstore.collection(`users`).doc(this.guard.uid);
    return list
  }


  UpdateAssessments(operating: Operating) {
    this.assessmentRef.update({
      busiName: operating.busiName,
      busiFirstName: operating.busiFirstName,
      busiLastName: operating.busiLastName,
      busiEmail: operating.busiEmail,
      busiTelephone: operating.busiTelephone,
      busiRegType: operating.busiRegType,
      practicalCompHistoryExistingCompany: operating.practicalCompHistoryExistingCompany,
      practicalCompHistoryExistingCustomerBase: operating.practicalCompHistoryExistingCustomerBase,
      practicalStrategyOperationsMethods: operating.practicalStrategyOperationsMethods,
      practicalStrategyCustomerService: operating.practicalStrategyCustomerService,
      practicalStrategyCustomerEngagement: operating.practicalStrategyCustomerEngagement,
      practicalBusiPlanArray: operating.practicalBusiPlanArray,
      practicalHREmployeeRetention: operating.practicalHREmployeeRetention,
      practicalHiringPractices: operating.practicalHiringPractices,
      practicalOpCRM: operating.practicalOpCRM,
      practicalOpSOP: operating.practicalOpSOP,
      practicalOpProductionProcess: operating.practicalOpProductionProcess,
      practicalLegalOpAgreement: operating.practicalLegalOpAgreement,
      practicalLegalDisclaimers: operating.practicalLegalDisclaimers,
      practicalLegalIP: operating.practicalLegalIP,
      capitalSeeking: operating.capitalSeeking,
      practicalFinancePaymentSystem: operating.practicalFinancePaymentSystem,
      practicalFinanceAccountingSystem: operating.practicalFinanceAccountingSystem,
      practicalFinance: operating.practicalFinance,
      practicalMarketingWebsite: operating.practicalMarketingWebsite,
      practicalMarketingBrand: operating.practicalMarketingBrand,
      practicalMarketingEffectiveness: operating.practicalMarketingEffectiveness,
      practicalMarketingNetworkMaterial: operating.practicalMarketingNetworkMaterial,
      practicalMarketingEmailList: operating.practicalMarketingEmailList,
      practicalMarketingSocialMedia: operating.practicalMarketingSocialMedia,
      revModel: operating.revModel,
      acceptTerms: operating.acceptTerms,
    });
  }
  DeleteAssessment() {
    this.assessmentRef = this.db.object('users/');
    this.assessmentRef.remove();
  }

}